import { OdataManager } from '@/api/odata/odata-manager';
import { RegisterExpertCommentary } from '@/api/model/interfaces';

export default class RegisterExpertCommentaryOdata extends OdataManager<RegisterExpertCommentary> {}
